import { render, staticRenderFns } from "./TepTurnoIndex.vue?vue&type=template&id=6c0782f6"
import script from "./TepTurnoIndex.vue?vue&type=script&lang=js"
export * from "./TepTurnoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports